var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowRightGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2511_5039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3786 8.73992C15.7879 8.33067 15.7879 7.66605 15.3786 7.2568L10.1402 2.01841C9.73097 1.60916 9.06635 1.60916 8.65711 2.01841C8.24786 2.42766 8.24786 3.09228 8.6571 3.50153L12.1112 6.95232L2.06656 6.95231C1.48706 6.95231 1.01888 7.42049 1.01888 7.99999C1.01888 8.57949 1.48706 9.04767 2.06656 9.04767L12.1079 9.04767L8.66038 12.4985C8.25113 12.9077 8.25113 13.5723 8.66038 13.9816C9.06963 14.3908 9.73425 14.3908 10.1435 13.9816L15.3819 8.74319L15.3786 8.73992Z",
    fill: "url(#paint0_linear_2511_5039)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2511_5039",
    x: 0.352539,
    y: 0,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2511_5039"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2511_5039",
    x1: 8.35221,
    y1: 14.2885,
    x2: 8.35221,
    y2: 1.71147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.33
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightGradient);
export default __webpack_public_path__ + "static/media/icon-arrow-right-gradient.40d48ae875c2941a27644a7059c48bd6.svg";
export { ForwardRef as ReactComponent };